import {
  Modal,
  ModalTitle,
  ModalCloseIconButton,
  ModalContent,
  ModalActions,
  ModalActionButton,
  Typography,
} from '@ace-clublabs/shared-component-library';

import { StoredPaymentAuthorizationText } from '../constants';

interface PaymentMethodsAuthorizationModalProps {
  handleClose: () => void;
  ctaText?: string;
}

const PaymentMethodsAuthorizationModal = ({ handleClose, ctaText }: PaymentMethodsAuthorizationModalProps) => {
  const getModalBodyText = (ctaText?: string) => {
    return (
      <div>
        {ctaText
          ? StoredPaymentAuthorizationText.replace('Pay Now button', `${ctaText} button`)
          : StoredPaymentAuthorizationText}
      </div>
    );
  };

  const title = 'Payment authorization';
  const id = title.toLowerCase().replace(/\s+/g, '-');

  const modalBodyText = getModalBodyText(ctaText);
  return (
    <Modal
      open={true}
      onClose={() => handleClose()}
      size="medium"
      variants={{ xs: 'bottom-sheet', sm: 'regular' }}
      aria-labelledby={`${id}-modal-title`}
      aria-describedby={`${id}-modal-content`}
      sx={{ height: '100%' }}
    >
      <ModalTitle id={`${id}-modal-title`}>
        {title}
        <ModalCloseIconButton aria-label="close" id={`${id}-close-button`} onClick={() => handleClose()} />
      </ModalTitle>

      <ModalContent id={`${id}-modal-content`}>
        <Typography variant="b1Regular">{modalBodyText}</Typography>
      </ModalContent>
      <ModalActions
        actionLayout={{
          sm: 'fullWidth',
          md: 'fullWidth',
          lg: 'rightAlign',
          xl: 'rightAlign',
        }}
      >
        <ModalActionButton id={`${id}-bottom-close-button`} label="Close" onClick={() => handleClose()} />
      </ModalActions>
    </Modal>
  );
};

export { PaymentMethodsAuthorizationModal };
